import {
  TextIcon,
  DividerIcon,
  QuoteIcon,
  VideoIcon,
  GalleryIcon,
  ImageIcon,
  TableIcon,
  PriceTableIcon,
  GoalTableIcon,
  FormIcon,
  AddFile,
  HTMLIcon,
  VariablesIcon,
  TestimonialIcon,
} from '../components/Icons';

export const ELEMENT_MENU = [
  {
    title: 'Typography',
    elements: [
      { type: 'text', title: 'Text', icon: <TextIcon /> },
      { type: 'divider', title: 'Divider', icon: <DividerIcon /> },
      { type: 'blockquote', title: 'Quote', icon: <QuoteIcon /> },
      { type: 'form', title: 'Form', icon: <FormIcon /> },
    ],
  },
  {
    title: 'Media',
    elements: [
      { type: 'image', title: 'Image', icon: <ImageIcon /> },
      { type: 'gallery', title: 'Gallery', icon: <GalleryIcon /> },
      { type: 'video', title: 'Video', icon: <VideoIcon /> },
      { type: 'attachment', title: 'Attach File', icon: <AddFile /> },
    ],
  },
  {
    title: 'More Elements',
    elements: [
      { type: 'table', title: 'Table', icon: <TableIcon /> },
      { type: 'price', title: 'Price Module', icon: <PriceTableIcon /> },
      { type: 'html', title: 'HTML', icon: <HTMLIcon /> },
      { type: 'miles', title: 'Goal Module', icon: <GoalTableIcon /> },
      { type: 'variable', title: 'Variables', icon: <VariablesIcon /> },
      { type: 'testimonial', title: 'Testimonial', icon: <TestimonialIcon /> },
    ],
  },
];
